import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/fieldReportTypes/${number | ':fieldReportTypeId'}/instances/${number | ':instanceIndex'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/fieldReportTypes/:fieldReportTypeId/instances/:instanceIndex`;

export const URL = (fieldReportId: number, fieldReportTypeId: number, instanceIndex: number): RouteDefinition =>
	`${baseRoute}/${fieldReportId}/fieldReportTypes/${fieldReportTypeId}/instances/${instanceIndex}`;
